import { ChangeDetectionStrategy, Component } from '@angular/core';
import { from } from 'rxjs';
import { User } from 'src/app/classes/models';
import { AuthService } from 'src/app/services/auth.service';
import { CompanyService } from 'src/app/services/company.service';
import { ImpersonationService } from 'src/app/services/impersonation.service';
import { SharedDataService } from 'src/app/services/shared-data.service';
import { ToastService } from 'src/app/services/toast.service';
import { companiesService } from 'src/app/shared/vive-api/companies.service';

@Component({
  selector: 'app-client-info',
  templateUrl: './client-info.component.html',
  styleUrls: ['./client-info.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ClientInfoComponent {
  constructor(
    private CompanyService: CompanyService,
    private SharedDataService: SharedDataService,
    private ImpersonationService: ImpersonationService,
    private ToastService: ToastService,
    private AuthService: AuthService
  ) {
    this.SharedDataService.listenForEvent().subscribe({
      next: ({ eventName, data }) => {
        if (eventName === 'SetCompanyId' && typeof data === 'number') {
          this.CompanyId = data;

          from(
            companiesService.findOneById({
              pathParams: { companyId: this.CompanyId }
            })
          ).subscribe({
            next: (Company) => {
              const { legalName } = Company;

              this.SharedDataService.sendEvent(
                'SetTitle',
                `Client - ${legalName}`
              );
            }
          });
        }
      }
    });

    this.SharedDataService.sendEvent('GetCompanyId');

    this.LoggedInUser = this.AuthService.getUser();
  }

  LoggedInUser: User;
  CompanyId?: number;

  showImpersonateButton() {
    if (this.LoggedInUser) {
      const { UserAccountRole: { role } = {} } = this.LoggedInUser;

      if (!role) {
        throw new Error('Missing user permission.');
      }

      return new Set([
        'ADMIN_ADMIN',
        'ADMIN_INSURANCE_TEAM',
        'ADMIN_FRAUD_TEAM',
        'ADMIN_CUSTOMER_SERVICE_TEAM',
        'ADMIN_PROJECT_MANAGEMENT_TEAM'
      ]).has(role);
    }

    return false;
  }

  viewClientProfile() {
    if (!this.CompanyId) {
      throw this.ToastService.addErrorToast('Error', 'Missing Client Id.', {
        returnError: true
      });
    }

    this.ImpersonationService.start({ companyId: this.CompanyId });
  }
}
